var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:[
    	'block-wrapper', 
    	_vm.componentClass, 
    	_vm.colorMode, 
    	_vm.styleClasses,
    	{
    		visible: _vm.visible, 
    		ready: _vm.ready
    	}
    ]},[(_vm.data.component_id==='component-2')?_c('a',{staticClass:"page-start-scroll-down",attrs:{"href":"#","role":"button"},on:{"click":function($event){$event.preventDefault();return _vm.scrollNow($event)}}},[_c('i',{staticClass:"ruter-ficon-chevron-down"})]):_vm._e(),_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns small-12"},[_c('div',{staticClass:"row"},[_c('div',{ref:"textColumn",class:_vm.textColumns,style:({ 
							order: _vm.textOrder,
							minHeight: _vm.mediaWrapperHeight
						})},[_c('wysiwyg-content',{ref:"textWrapper",class:[{ 
								'center-vertically': _vm.verticallyCenterText
							}],attrs:{"data":_vm.data.wysiwyg_content,"columns":2}})],1),_c('div',{class:_vm.mediaColumns,style:({ order: _vm.mediaOrder})},[_c('media-content',{ref:"mediaWrapper",attrs:{"data":_vm.data.media_content,"ready":_vm.ready},on:{"heightChange":_vm.handleMediaHeightChange}})],1)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }